import React, { Fragment, memo, useRef, useState } from 'react'
import { CircleButton, Label } from '../../components'
import { ReactComponent as CloseIcon } from '../../images/icons/times-pro.svg'
import axios from 'axios'
import ModalConfirm from '../../components/ModalConfirm'

function List (props) {
  let {
    id,
    name,
    label,
    helpText,
    value,
    context,
    unlabeled,
  } = props
  if (unlabeled) {
    helpText = null
    label = null
  }
  const listState = context.getChildContext(name)
  const listIsMutable = listState ? listState.mutable : context.mutable
  const [activeIndex, activateIndex] = useState(
    listState ? -1 : (props.activate ? 0 : -1))
  const [deleteCount/* , setDeleteCount */] = useState(0)
  const importFileRef = useRef(null)
  const handleListItemChange = (key, val, idx) => {
    if (!listState) {
      // change to a primitive list, not an object list
      context.mutateListVarData(key, idx, val)
    }
    activateIndex(-1)
  }

  const handleListDeleteItem = index => () => {
    const newActive = (index > 0) ? index - 1 : index
    let newArray
    if (listState) { // props.type === 'object'
      newArray = listState.deleteObject(index)
    } else { // props.type !== 'object'
      context.deleteListVarData(name, index)
      newArray = context.getValue(name)
    }
    if (newArray && newArray.length > 0) {
      activateIndex(newActive)
    }
  }
  const handleAdd = () => {
    let newIndex
    if (listState) { // props.type === 'object') {
      newIndex = listState.addNewObject()
    } else { // props.type !== 'object'
      newIndex = (value && value.length) || 0
      context.mutateListVarData(name, newIndex, '')
    }
    activateIndex(newIndex)
  }


  const listItemFactory = (props, listState, idx) => {
    const {
      id,
      value,
      factory,
      ...otherProps
    } = props
    const itemId = id + '.' + idx
    const itemProps = {
      ...otherProps,
      id: itemId,
      index: idx,
      activate: (idx === activeIndex) ? true : null,
    }
    if (listState) { // if you have a list of objects, not primitives
      itemProps.context = listState
    } else if (props.activate && idx === 0) {
      itemProps.activate = true
    }
    return factory(itemProps, value[idx], handleListItemChange)
  }
  const onEnter = event => {
    if (event.keyCode === 13) {
      event.stopPropagation()
      event.preventDefault()
      handleAdd()
    }
  }
  const importItems = async (event) => {
    const getItemsFromFile = async () => {
      const file = event.target.files[0]
      if (file.type === 'text/csv' ||
        file.name.toLowerCase().endsWith('.csv')) {
        const formData = new FormData()
        formData.append('file', file)

        const { data: Records } = await axios.post('/upload/parse/csv',
          formData)
        return Records
      } else {
        const getJSON = (File) => new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = async () => {
            try {
              const { data } = await axios.get(reader.result, {
                url: '',
                baseURL: '',
              })
              resolve(data)
            } catch (e) {
              reject(e)
            }
          }
          reader.onerror = error => reject(error)
          reader.readAsDataURL(File)
        })
        let values = await getJSON(file)
        if (Array.isArray(values)) {
          return values
        } else {
          return [values]
        }
      }
    }

    const Items = await getItemsFromFile()
    if (listState) {
      listState.addObjects(Items)
    }
  }

  const openImportItems = () => {
    if (importFileRef.current) {
      importFileRef.current.click()
    }
  }

  const ImportBlock = (<div className="ml-4">
    <input id={'importFile1'} ref={importFileRef} type={'file'}
           accept={'.csv, application/json'}
           className={'d-none'}
           onChange={importItems}/>
    <CircleButton id={id + '|import'} icon={'icon-Import'}
                  label={'Import CSV or JSON'}
                  onClick={openImportItems}/>
  </div>)

  const canUseImport = props.useImport || false
  const hasAnyValue = Array.isArray(value) && value.length > 0
  return (
    <Fragment>
      <Label name={name} label={label} helpText={helpText} idFor={null}/><br/>
      {Array.isArray(value)
        ? value.map(
          (val, idx) => (
            <div key={id + deleteCount + '-' + idx} className={'d-flex'}
                 onKeyUp={onEnter}>
              {listItemFactory(props, listState, idx)}
              {listIsMutable && listState ? (
                <ModalConfirm
                  title={'Are you sure you want to delete this item?'}
                  submit={handleListDeleteItem(idx)}>
                  <div>
                    <CloseIcon className={'m-2 timesBtn'}/>
                  </div>
                </ModalConfirm>) : (
                <div onClick={handleListDeleteItem(idx)}>
                  <CloseIcon className={'m-2 timesBtn'}/>
                </div>
              )}
            </div>
          ),
        )
        : ''}
      {listIsMutable && (
        <div className={'d-flex'}>
          <CircleButton id={id + '|add'} icon={'icon-plus2'}
                        label={hasAnyValue ? 'Add another' : 'Click to Add'}
                        onClick={handleAdd}/>
          {canUseImport &&
            ImportBlock}
        </div>
      )}
    </Fragment>
  )
}

export default memo(List)
